import apps from '@/API/services/apps';
import editor from '@/API/services/editor';
import miniToastr from 'mini-toastr';
import router from '@/router/';

const getDefaultState = () => {
  return {
    apps: [],
  }
}

const state = getDefaultState()
const actions = {
  resetAppsState: ({ commit }) => {
    commit('RESET_STATE');
  },
  getApps: async ({ commit }, payload) => {
    try {
      if(!payload.c) return;
      const response = await apps.fetchApps(payload);
      commit('SET_APPS', response);
    } catch (err) {
      console.log(err);
    }
  },
  createNewApp: async ({ commit, dispatch }, payload) => {
    try {
      const response = await apps.createApp(payload);
      commit('CREATE_NEW_APP', {
        name: payload.appName,
        appId: response.data.app_id,
        clientHash: payload.clientHash,
        interfaces: [],
        disabled: [],
      });

      dispatch('getApps', {
        c: router.history.current.query.c,
        q: '',
      });

      miniToastr.success(`You have created new app ${payload.appName}!`, ' ');

      return response.data.app_id;
    } catch (err) {
      console.log(err);
    }
  },
  deleteApp: async ({ commit }, payload) => {
    try {
      await apps.deleteUniqueApp(payload);
      commit('DELETE_APP', payload);
      miniToastr.success('You have deleted app!', ' ');
    } catch (err) {
      console.log(err);
    }
  },
  copyApp: async ({ commit, dispatch }, payload) => {
    try {
      await apps.copyApp(payload);
      commit('COPY_APP', {
        ...payload.app,
        name: payload.appName,
        real_name: payload.appName,
        appID: payload.appID,
      });

      miniToastr.success(`You have copied app ${payload.appName}!`, ' ');
    } catch (err) {
      console.log(err);
    } finally {
      dispatch('getApps', {
        c: router.history.current.query.c,
        q: '',
      });
    }
  },
  renameApp: async ({ commit }, payload) => {
    try {
      payload.appID = payload.app.appID
      await apps.renameCurrentApp(payload);
      commit('RENAME_APP', payload);
      miniToastr.success('You have renamed app!', ' ');
    } catch (err) {
      console.log(err);
    }
  },
  // Interfaces actions
  createNewInterface: async ({ commit, dispatch }, payload) => {
    try {
      const { data } = payload.type === 'environments' ? await apps.createNewEnvironment(payload) : await apps.createInterface(payload);
      commit('CREATE_NEW_INTERFACE', payload);
      dispatch('getApps', {
        c: router.history.current.query.c,
        q: '',
      });
      const successMessage = `You have created new ${ payload.type === 'environments' ? 'environment' : 'interface' }`
      miniToastr.success(`${successMessage} ${payload.name}!`, ' ');
      return data.interface_hash;
    } catch (err) {
      miniToastr.error(`Can't create ${payload.name}`);
      console.log(err);
    }
  },
  deleteInterface: async ({ commit, dispatch }, payload) => {
    try {
      await apps.deleteInterface(payload);
      commit('DELETE_INTERFACE', payload);
      console.log('delintf',payload);
      dispatch('getApps', {
        c: payload.clientHash,
        q: '',
      });
      const successMessage = `You have deleted ${ payload.type === 'environments' ? 'environment' : 'interface' }`
      miniToastr.success(`${successMessage} ${payload.interface.real_name}!`, ' ');
      editor.saveGroup({
        ...payload.app.app_groups,
        clientHash: payload.clientHash,
        appHash: payload.appID,
      });
    } catch (err) {
      console.log(err);
    }
  },
  copyInterface: async ({ commit, dispatch }, payload) => {
    try {
      const { data } = await apps.copyInterface(payload);
      commit('COPY_INTERFACE', payload);
      dispatch('getApps', {
        c: router.history.current.query.c,
        q: '',
      });

      miniToastr.success(`You have copied interface ${payload.interface.real_name}!`, ' ');
      return data.interface_hash;
    } catch (err) {
      console.log(err);
    }
  },
  copyEnvironment: async ({ commit, dispatch }, payload) => {
    try {
      await apps.copyEnvironment(payload);
      commit('COPY_INTERFACE', payload);
      dispatch('getApps', {
        c: router.history.current.query.c,
        q: '',
      });
      miniToastr.success(`You have copied environment ${payload.interface.real_name}!`, ' ');
    } catch (err) {
      console.log(err);
    }
  },
  renameEnvironment: async ({ commit, dispatch }, payload) => {
    try {
      await apps.renameCurrentEnvironment(payload);
      commit('RENAME_ENVIRONMENT', payload);
      dispatch('getApps', {
        c: router.history.current.query.c,
        q: '',
      });
      miniToastr.success(`You have renamed environment ${payload.interface.real_name}!`, ' ');
    } catch (err) {
      console.log(err);
    }
  },
  renameInterface: async ({ commit, dispatch }, payload) => {
    try {
      await apps.renameCurrentInterface(payload);
      commit('RENAME_INTERFACE', payload);
      dispatch('getApps', {
        c: router.history.current.query.c,
        q: '',
      });
      miniToastr.success(`Successfully renamed interface to ${payload.interface.real_name}`, ' ');
    } catch (err) {
      console.log(err);
    }
  },
  // eslint-disable-next-line
  toggleInterfaceStatus: async ({}, payload) => {
    try {
      await apps.toggleInterface(payload);

    } catch (err) {
      console.log(err);
    }
  },
  dragInterface: async ({ dispatch, state }, payload) => {
    const targetApp = state.apps.find(xxx => xxx.appID === payload.targetAppHash);
    const rootApp = state.apps.find(xxx => xxx.appID === payload.parentID);
    const rootInterface = rootApp.interfaces.find(item => item.name === payload.interfaceHash);

    const type = payload.type;

    if (targetApp.appID !== rootApp.appID) {
      try {
        if(type === 'interfaces') {
          const { data } = await apps.copyInterface({
            clientHash: targetApp.clientHash,
            appHash: rootApp.appID,
            interface: rootInterface,
            targetApp: targetApp.appID,
          });

          miniToastr.success(`You have copied interface ${rootInterface.real_name} to ${targetApp.real_name}`, '');

          dispatch('getApps', {
            c: router.history.current.query.c,
            q: '',
          });

          return data;
        }
        else if(type === 'environments') {
          const { data } = await apps.copyEnvironment({
            clientHash: targetApp.clientHash,
            appHash: rootApp.appID,
            interface: rootInterface,
            targetApp: targetApp.appID,
          });

          miniToastr.info(`You have copied your environment ${rootInterface.real_name} to ${targetApp.real_name}`, 'Copied!');

          dispatch('getApps', {
            c: router.history.current.query.c,
            q: '',
          });

          return data;
        }
      } catch (err) {
        console.log(err)
      }
    }
  },
}
const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_APPS: (state, payload) => {
    const lengthOfApps = Object.getOwnPropertyNames(payload.data).length;
    const apps = payload.data;

    let i = 0;
    for (i; i < lengthOfApps; i++) {
      const appHash = Object.keys(payload.data)[i];
      apps[appHash] = payload.data[appHash];
      apps[appHash].name = appHash;
    }

    const appsArray = Object.keys(apps).map(key => {
      return apps[key];
    });

    state.apps = appsArray;
    state.apps = state.apps.sort((a, b) => (a.org_name > b.org_name) ? 1 : -1);
  },
  CREATE_NEW_APP: (state, payload) => {
    state.apps.push(payload);
  },
  DELETE_APP: (state, payload) => {
    state.apps = state.apps.filter(app => app.appID !== payload.appID);
  },
  COPY_APP: (state, payload) => {
    state.apps.push(payload);
  },
  RENAME_APP: (state, payload) => {
    state.apps.forEach(item => {
      item.appID === payload.app.appID ? item.real_name = payload.newAppName : false;
    });
  },
  // Interfaces mutations
  CREATE_NEW_INTERFACE: (state, payload) => {
    //TODO URLEncode the payload.*
    state.apps.forEach(item => {
      if (item.appID === payload.appID) {
        item.interfaces.push({
          icon: 'server',
          disabled: false,
          real_name: '',
          name,
          url: `${payload.organisationName}/${payload.appID}/${payload.name}`,
        });
      }
    });
  },
  DELETE_INTERFACE: (state, payload) => {
    state.apps.forEach(item => {
      if (item.appID === payload.appID) {
        Object.keys(item.app_groups).forEach(groupname => {
          item.app_groups[groupname] = item.app_groups[groupname].filter(element => element !== payload.interface.hash)
        });
        item.interfaces = item.interfaces.filter(element => element.hash !== payload.interface.hash);
      }
    });
  },
  COPY_INTERFACE: (state, payload) => {
    state.apps.forEach(item => {
      item.appID === payload.appID ? item.interfaces.push(payload.interface) : false;
    });
  },
  COPY_ENVIRONMENT: (state, payload) => {
    state.apps.forEach(item => {
      item.appID === payload.appID ? item.environments.push(payload.interface) : false;
    });
  },
  RENAME_INTERFACE: (state, payload) => {
    state.apps.forEach(item => {
      if (item.appID === payload.appID) {
        item.interfaces.forEach(element => {
          if (element.interfaceID === payload.interface_hash) {
            element.real_name = payload.newInterfaceName;
          }
        });
      }
    });
  },
  RENAME_ENVIRONMENT: (state, payload) => {
    state.apps.forEach(item => {
      if (item.appID === payload.appID) {
        item.environments.forEach(element => {
          if (element.interfaceID === payload.interface_hash) {
            element.real_name = payload.newInterfaceName;
          }
        });
      }
    });
  },
}

export default {
  state,
  mutations,
  actions,
};
